var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcMoveTicket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1118 2.77778L9.33398 1M9.33398 1L7.55621 2.77778M9.33398 1V17M9.33398 17L11.1118 15.2222M9.33398 17L7.55621 15.2222M15.5562 10.7778L17.334 9M17.334 9L15.5562 7.22222M17.334 9H1.33398M1.33398 9L3.11176 10.7778M1.33398 9L3.11176 7.22222",
    stroke: "#4F5662",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMoveTicket);
export default __webpack_public_path__ + "static/media/ic-move-ticket.8baf565afe3eddb556038e50c28456b6.svg";
export { ForwardRef as ReactComponent };